module.exports = "/images/in-progress-form-icon.png?926094e80249e74d18cab2c6b9fd2cef";